// extracted by mini-css-extract-plugin
export var base = "_1m-0";
export var updateBanner = "_1m-1";